var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChevronDownIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 6L8 10L4 6",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronDownIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ChevronDownIcon.c31f6212.svg";
export { ForwardRef as ReactComponent };